import React from "react";
import { withRouter } from "react-router-dom";

import Api from "../../../lib/componentApi";
import getComponentData from "../../../lib/getComponentData";
import getAppStrings from "../../../lib/appStrings";

import Detail from "../../../components/Restaurants/Detail";
import CommonHeader from "../../../components/Common/Header/";
import RestaurantLoading from "../../../components/Loadings/Restaurant";
import NotFound from "../Common/NotFound";
import getHeaderData from "../../../lib/getHeaderData";
import getNestedObject from "../../../lib/getNestedObject";
import getRestaurantsLink from "../../../lib/getRestaurantsLink";
import setLocalDeliveryData from "../../../lib/setLocalDeliveryData";
import customUrlSearchParams from "../../../lib/customUrlSearchParams";
var service = require("../../../../public/service.json");

class Restaurant extends React.Component {
  constructor(props, context) {
    super(props, context);
    const staticContext = props.staticContext;
    const { initialData, serverData, mobile } = getComponentData(
      staticContext,
      "restaurant"
    );
    const matchParams = props.match.params;
    const { userBasketData } = getHeaderData(staticContext, "user");
    let basketData = userBasketData;
    const searchParams = new customUrlSearchParams(props.location.search);
    let restaurant = null;
    if (initialData) {
      restaurant = initialData;
    }

    let deliveryDetails;
    // eslint-disable-next-line
    if (__isBrowser__) {
      deliveryDetails = localStorage.getItem("deliveryDetails");
    } else {
      deliveryDetails = serverData;
    }
    const addressData = (deliveryDetails && JSON.parse(deliveryDetails)) || {};
    let closed =
      !(restaurant && !restaurant.restaurantStatusCode) && service.isAlive;
    let { hash } = props.location || "";

    if (hash) {
      hash = hash.split("-")[0];
    }
    const userAddressId = getNestedObject(addressData, ["userAddressId"], null);
    const routeName = getNestedObject(addressData, ["routeName"], "");
    const postalCode =
      searchParams.get("postcode") ||
      getNestedObject(addressData, ["postalCode"], "");
    const city = matchParams.city;

    const addressLine2 = getNestedObject(addressData, ["addressLine2"], "");
    const title = getNestedObject(addressData, ["title"], "");
    const flatNumber = getNestedObject(addressData, ["flatNumber"], "");
    const lat = getNestedObject(addressData, ["lat"], null);
    const lon = getNestedObject(addressData, ["lon"], null);
    const preOrder = searchParams.get("time")
      ? searchParams.get("time") === "now"
        ? ""
        : searchParams.get("time")
      : addressData.preOrder;

    // eslint-disable-next-line
    if (__isBrowser__) {
      if (hash && !closed) {
        var body = document.body;
        body.classList.add("body-overflow");
      }
      if (!Object.keys(addressData).length && postalCode && city) {
        const apiPostalCode = postalCode || "00000";
        Api.post(
          "/api/route/data",
          { postalCode: apiPostalCode },
          (postalResponse, postalErros) => {
            if (postalErros) {
              if (postalErros === 503) {
                this.setState(() => {
                  throw postalErros;
                });
              } else {
                console.log(postalErros, "postal code query error");
              }
            } else if (postalResponse.code) {
              console.log(postalCode.response);
            } else {
              const { adminWard, city, lat, lon } = postalResponse;
              const addressData = {
                preOrder,
                postalCode,
                delivery: true,
                adminWard: adminWard.slugAdminWard,
                city: city.slugName,
                lat,
                lon,
                isPostalCode: true
              };
              const jsonData = JSON.stringify(addressData);
              setLocalDeliveryData(jsonData, () => {});
            }
          }
        );
      }
    }

    this.state = {
      restaurant,
      basketData,
      userAddressId: userAddressId,
      routeName,
      postalCode,
      addressLine2,
      title,
      flatNumber,
      delivery:
        typeof addressData.delivery === "boolean" ? addressData.delivery : true,
      preOrder,
      lat,
      lon,
      slugName: props.match.params.restaurantUid || "",
      addItem: !!hash && !closed,
      itemId: (!!hash && !closed && hash.replace("#", "")) || "",
      reviewSection: false,
      loading: false,
      selectedTab: null,
      closedMessage: null,
      enterPostCode: !restaurant && !postalCode,
      selectDelivery: false,
      closedTitle: null,
      isMobile: mobile
    };
  }
  componentDidMount() {
    window.addEventListener("popstate", this.handlePopState, false);
  }
  componentWillUnmount() {
    window.removeEventListener("popstate", this.handlePopState, false);
  }
  handlePopState = () => {
    var body = document.body;
    let href = getRestaurantsLink();
    body.classList.remove("body-overflow");
    this.setState(
      {
        itemId: "",
        addItem: false
      },
      () => {
        window.location.replace(href);
      }
    );
  };
  handleClearBasket = updateBasket => {
    Api.post("/api/product/clear/basket", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response.code);
      } else {
        if (response.status) {
          this.setState({ infoMessage: "" });
          updateBasket(null, true);
        }
      }
    });
  };
  closeInfoMessage = () => {
    var body = document.body;
    const { history, location } = this.props;
    const { pathname, search } = location;
    this.setState(
      {
        infoMessage: "",
        addItem: false,
        itemId: ""
      },
      () => {
        body.classList.remove("body-overflow");
        history.push({
          pathname,
          search
        });
      }
    );
  };
  handleSelectItem = (itemId, closedMessage) => {
    const { routeName, postalCode, basketData, restaurant } = this.state;
    var body = document.body;
    body.classList.add("body-overflow");
    if (itemId) {
      if (
        basketData &&
        basketData.restaurant &&
        basketData.restaurant.uid !== restaurant.uid
      ) {
        const infoMessage = getAppStrings(4033);
        this.setState({
          infoMessage:
            (infoMessage &&
              infoMessage.message &&
              infoMessage.message.replace(
                "[:par1]",
                `${basketData.restaurant.name}`
              )) ||
            "You cant add this item to your basket because it's from a different restaurant",
          addItem: true,
          itemId
        });
      } else {
        if (!routeName && !postalCode) {
          this.setState({
            enterPostCode: true
          });
        } else {
          if (closedMessage) {
            const infoMessage = getAppStrings(3012);
            this.setState({
              closedMessage:
                (infoMessage && infoMessage.message) || closedMessage,
              closedTitle: (infoMessage && infoMessage.title) || null
            });
          } else {
            this.setState({
              addItem: true,
              itemId
            });
          }
        }
      }
    }
  };
  getRestaurantData = ({
    postalCode,
    routeName,
    addressLine2,
    flatNumber,
    latLonData,
    status
  }) => {
    if (latLonData && latLonData.lat && latLonData.lon && postalCode) {
      this.setState(
        {
          postalCode,
          routeName,
          addressLine2,
          flatNumber,
          lat: latLonData.lat,
          lon: latLonData.lon
        },
        () => {
          let {
            slugName,
            delivery,
            preOrder,
            userAddressId,
            lat,
            lon
          } = this.state;
          if (!userAddressId) {
            userAddressId = 0;
          }
          if (typeof delivery !== "boolean") {
            delivery = true;
          }
          Api.get(
            "/api/restaurant",
            { slugName, delivery, preOrder, userAddressId, lat, lon },
            (response, errors) => {
              if (errors) {
                if (errors === 503) {
                  this.setState(() => {
                    throw errors;
                  });
                } else {
                  console.log(errors);
                }
              } else if (response.code) {
                console.log(response, "code-basket");
              } else {
                this.setState({ restaurant: response, enterPostCode: false });
              }
              this.setState({
                loading: false
              });
            }
          );
        }
      );
    } else {
      let {
        slugName,
        delivery,
        preOrder,
        userAddressId,
        lat,
        lon
      } = this.state;
      if (!userAddressId) {
        userAddressId = 0;
      }
      if (!lat || !lon) {
        lat = 0;
        lon = 0;
      }
      if (typeof delivery !== "boolean") {
        delivery = true;
      }
      if (!status) {
        if (!(lat && lon) && !userAddressId) {
          this.setState({ enterPostCode: true });
        }
      } else {
        this.setState({ enterPostCode: false });
      }
      Api.get(
        "/api/restaurant",
        { slugName, delivery, preOrder, userAddressId, lat, lon },
        (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            console.log(response, "code-restaurant");
          } else {
            this.setState({ restaurant: response });
          }
          this.setState({
            loading: false
          });
        }
      );
    }
  };
  getRestaurantItems = callback => {
    const { delivery = true, preOrder = "", restaurant } = this.state;
    const variables = { delivery, preOrder, restaurantUid: restaurant.uid };
    this.setState({
      loading: true
    });
    Api.post("/api/restaurant/items", variables, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-restaurant");
      } else {
        const items = response.items || [];
        this.setState({
          restaurant: { ...this.state.restaurant, ...{ items } },
          addItem: false,
          itemId: ""
        });
      }
      if (callback) {
        callback();
      }
      this.setState({
        loading: false
      });
    });
  };
  handlePostCode = value => {
    const boolVal = Boolean(value);
    if (!boolVal) {
      var body = document.body;
      body.classList.remove("body-overflow");
    }
    this.setState({
      enterPostCode: boolVal
    });
  };
  handleCloseItem = (e, basketData) => {
    var body = document.body;
    body.classList.remove("body-overflow");
    const { history, location } = this.props;
    const { pathname, search } = location;
    history.push({
      pathname,
      search
    });
    if (basketData) {
      this.setState(
        {
          basketData
        },
        () => {
          this.getRestaurantItems();
        }
      );
    } else {
      this.getRestaurantItems();
    }
  };
  onClickClose = () => {
    var body = document.body;
    body.classList.remove("body-overflow");
    const { history, location } = this.props;
    const { pathname, search } = location;
    this.setState(
      {
        closedMessage: null,
        closedTitle: null
      },
      () => {
        history.push({
          pathname,
          search
        });
      }
    );
  };
  render() {
    const {
      restaurant,
      userAddressId,
      routeName,
      postalCode,
      addressLine2,
      flatNumber,
      title,
      basketData,
      delivery,
      preOrder,
      addItem,
      itemId,
      closedMessage,
      closedTitle,
      enterPostCode,
      loading,
      infoMessage,
      selectDelivery,
      isMobile
    } = this.state;
    const isAlive = service.isAlive;
    return (
      (loading && <RestaurantLoading />) ||
      (restaurant && (
        <React.Fragment>
          <CommonHeader />
          <Detail
            onSelectItem={this.handleSelectItem}
            restaurant={restaurant}
            routeName={routeName}
            userAddressId={userAddressId}
            postalCode={postalCode}
            title={title}
            basketData={basketData}
            delivery={delivery}
            preOrder={preOrder}
            addressLine2={addressLine2}
            enterPostCode={enterPostCode}
            selectDelivery={selectDelivery}
            flatNumber={flatNumber}
            itemId={itemId}
            getRestaurantDetail={this.getRestaurantData}
            onCloseItem={this.handleCloseItem}
            closedMessage={closedMessage}
            closedTitle={closedTitle}
            addItem={addItem}
            onClickClose={this.onClickClose}
            handlePostCode={this.handlePostCode}
            infoMessage={infoMessage}
            handleClearBasket={this.handleClearBasket}
            closeInfoMessage={this.closeInfoMessage}
            isAlive={isAlive}
            isMobile={isMobile}
            getRestaurantItems={this.getRestaurantItems}
          />
        </React.Fragment>
      )) || <NotFound />
    );
  }
}

export default withRouter(Restaurant);
